export const allClassData = [
  {
    className: 'Play',
  },
  {
    className: 'Nursery',
  },
  {
    className: 'One-Boys',
  },
  {
    className: 'One-Girls',
  },
  {
    className: 'Two-Boys',
  },
  {
    className: 'Two-Girls',
  },
  {
    className: 'Three-Boys',
  },
  {
    className: 'Three-Girls',
  },
  {
    className: 'Four-Boys',
  },
  {
    className: 'Four-Girls',
  },
  {
    className: 'Five-Boys',
  },
  {
    className: 'Five-Girls',
  },
  {
    className: 'Six-Boys',
  },
  {
    className: 'Six-Girls',
  },
  {
    className: 'Seven-Boys',
  },
  {
    className: 'Seven-Girls',
  },
  {
    className: 'Eight-Boys',
  },
  {
    className: 'Eight-Girls',
  },
  {
    className: 'Nine-Boys',
  },
  {
    className: 'Nine-Girls',
  },
  {
    className: 'Ten-Boys',
  },
  {
    className: 'Ten-Girls',
  },
];

export const ClassData = [
  {
    className: 'Play',
    mark: 400,
  },
  {
    className: 'Nursery',
    mark: 400,
  },
  {
    className: 'One',
    mark: 400,
  },
  {
    className: 'Two',
    mark: 400,
  },
  {
    className: 'Three',
    mark: 420,
  },
  {
    className: 'Four',
    mark: 420,
  },
  {
    className: 'Five',
    mark: 600,
  },
  {
    className: 'Six',
    mark: 750,
  },
  {
    className: 'Seven',
    mark: 750,
  },
  {
    className: 'Eight',
    mark: 750,
  },
  {
    className: 'Nine',
    mark: 1150,
  },
  {
    className: 'Ten',
    mark: 1150,
  },
];
